<template>
    <customModal :containersm="true" :footerShow="true" @closeModal="$emit('closeApproveModal')">
        <template #title>
           {{ title }}
        </template>

        <template #body>
            <label class="col-form-label">Comments</label>
            <textarea class="form-control message-input" name="message" placeholder="Enter your comments here"
                v-model="localComments"></textarea>
        </template>

        <template #footer>
            <div class="text-center">
                <button type="button" class="btn btn-green-new btn-sm py-0 text-white mr-2" @click="ActionSubmit(true)">
                  {{ action1 }}
                </button>
                <button type="button" class="btn btn-danger-new btn-sm py-0 px-3 mr-2" @click="ActionSubmit(false)">
                  {{ action2 }} 
                </button>
            </div>
        </template>
    </customModal>
</template>
<script src="./ApproveRejectPopUp.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/css/custom.css";
.create-user-modal1 {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0/18%);
  /* display: flex; */
  /* align-items: center; */
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
  align-items: flex-start !important;
}
.modal1 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-width {
  width: min(400px, 90%);
}

.btn-primary1 {
  color: #fff;
  background-color: #145faf;
  /* border-color: #1ab394; */
  border: none;
}

.modal-content1 {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 150%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-header-user {
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

.close-user {
  cursor: pointer;
}

.create-user-modal {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0/18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.modal-content2 {
  position: relative;
  display: flex;
  flex-direction: column;
  /* width: 200%; */
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.ibox-content-project {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 8px 20px 8px;
  border-color: #e7eaec;
  -o-border-image: none;
  border-image: none;
  border-style: solid;
  border-width: 1px;
}

.project-list1 table tr td {
  border-top: none;
  border-bottom: 1px solid #e7eaec;
  vertical-align: middle;
}

.scrollable-block {
  overflow-y: auto;
  height: 450px;
}

.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 0;
  top: -35px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.btn-green-new {
  color: #fff;
  background-color: #1ab394;
  /* border-color: #1ab394; */
  border: none;
}
.btn-danger-new {
  color: #fff;
  background-color: #ed5565;
  border: none;
}
.modal-footer-new {
  margin-top: 0;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: 0.3rem;
  /* border-bottom-left-radius: .3rem; */
}
.approve {
  padding: 10px 15px;
}
</style>
